<div class="d-flex position-relative">
  @if (showCount) {
    <div
      class="more-count position-absolute fw-medium"
      [style.left.px]="showingDisplay * notOverlapSize"
      [style.width.px]="size"
      [style.height.px]="size"
      [style.font-size.px]="fontSize || size * 0.5"
      [style.background]="'#BDBFC7'"
      [style.border-color]="'#BDBFC7'"
    >
      +{{ count - showingDisplay }}
    </div>
  }
  @for (display of _displayList; track display; let index = $index) {
    <div
      class="position-absolute"
      [style.left.px]="
        (_displayList.length - 1 - index) * notOverlapSize
      "
    >
      @switch (display.unit) {
        @case ('person') {
          <app-profile-display
            [person]="display.display"
            [borderColor]="'#EAEAED'"
            [size]="size"
            [fontSize]="fontSize || size * 0.5"
          ></app-profile-display>
        }
        @case ('department') {
          <app-profile-display
            [borderColor]="'#EAEAED'"
            [size]="size"
            [person]="display.display"
            [defaultPhoto]="'assets/images/default-dept.png'"
          ></app-profile-display>
        }
      }
    </div>
  }
</div>
